import { Link } from 'react-router-dom';
import { buttonClass } from '@/components/ui/Button';
import { TextoRico } from '@/components/ui/TextoRico';
import { useI18n } from '@/hooks/useI18n';
import styles from './Hero.module.css';

export function Hero() {
  const { t } = useI18n();
  const h = t.marketing.hero;

  return (
    <section className={styles.hero} id="hero">
      <div className={['ilu-container', styles.grid].join(' ')}>
        <div>
          <span className="ilu-eyebrow">{h.eyebrow}</span>
          {/* El degradado va sobre un fragmento *dentro* de la frase; ver
              `TextoRico` para por qué el marcado viaja en el texto. */}
          <h1 className={styles.title}>
            <TextoRico texto={h.titulo} />
          </h1>
          <p className={styles.lead}>{h.lead}</p>
          <p className={styles.support}>{h.apoyo}</p>
          <div className={styles.ctas}>
            <Link to="/contacto" className={buttonClass({ variant: 'primary', size: 'lg' })}>
              {h.ctaPrimary}
            </Link>
            <a href="#planes" className={buttonClass({ variant: 'outline', size: 'lg' })}>
              {h.ctaSecondary}
            </a>
          </div>
        </div>

        <div className={styles.media}>
          {/*
            El video pesa ~3 MB. `preload="none"` + `poster` evitan que compita
            con el LCP: el navegador pinta el poster y solo descarga el video
            cuando el usuario lo reproduce.
          */}
          <video
            controls
            muted
            playsInline
            preload="none"
            poster="/recursos/dashboard.png"
            aria-label={h.videoLabel}
          >
            <source src="/ilumetria2.mp4" type="video/mp4" />
            {h.videoFallback}
          </video>
        </div>
      </div>
    </section>
  );
}
